import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/auth";
import "firebase/compat/functions";
import "firebase/compat/storage";
import "firebase/compat/analytics";

import { firebaseConfig } from "@/config/firebase.config";

const PROD_PROJECT_ID = "quebec-river-database";
const useEmulators = process.env.VUE_APP_USE_EMULATORS === "true";

// Safety net: the local dev server must never talk to production by accident.
// `npm run serve` reads .env.development.local (dev project), `npm run serve:emu` reads .env.emulator.
// Set VUE_APP_ALLOW_PROD_IN_DEV=true only if you really mean to point a dev server at prod.
if (
  process.env.NODE_ENV === "development" &&
  firebaseConfig.projectId === PROD_PROJECT_ID &&
  process.env.VUE_APP_ALLOW_PROD_IN_DEV !== "true"
) {
  throw new Error(
    `Dev server is configured for the PRODUCTION Firebase project (${PROD_PROJECT_ID}). ` +
      "Fill .env.development.local with the dev project config (see docs/DEV_ENVIRONMENT.md).",
  );
}

const app = firebase.initializeApp(firebaseConfig);

const db = firebase.firestore();
const auth = firebase.auth();
const functions = app.functions("northamerica-northeast1");
const storage = firebase.storage();
const analytics = firebaseConfig.measurementId && !useEmulators ? firebase.analytics() : null;

if (useEmulators) {
  const host = process.env.VUE_APP_EMULATOR_HOST || "127.0.0.1";
  db.useEmulator(host, 8080);
  auth.useEmulator(`http://${host}:9099`, { disableWarnings: true });
  functions.useEmulator(host, 5001);
  storage.useEmulator(host, 9199);
  console.info(`[firebase] Using local emulators on ${host} (project ${firebaseConfig.projectId})`);
} else if (process.env.NODE_ENV === "development") {
  console.info(`[firebase] Using cloud project ${firebaseConfig.projectId}`);
}

// Disable collection by default — enabled only after explicit user consent.
if (analytics) {
  analytics.setAnalyticsCollectionEnabled(false);
}

function setAnalyticsConsent(enabled) {
  if (analytics) {
    analytics.setAnalyticsCollectionEnabled(enabled);
  }
}

const { TimeStamp, GeoPoint } = firebase.firestore;

export { app, db, auth, functions, storage, analytics, setAnalyticsConsent, TimeStamp, GeoPoint };
